export default "__VITE_ASSET__CixnKhBb__"